<template>
  <div class="home-wrapper">
	  <!-- transform:'scale('+(w/960)+')','transform-origin': '0% 0%' -->
	  <div class="home-wrapper-top">
		  <div class="top-logo" >
			  <img @click="showTK('tk6')"  class="top-more-icon a-hide b-hide" :src="g+'/gengduo.png'" />
			  <img @click="$router.push('/')" class="top-logo-icon" src="@/assets/imgs/logos/sisley-logo_black-bigger.svg" />
		  </div>
		  <div class="c-hide" >
				 <ul class="menu-list">
					 <!-- 1 -->
					 <li :class="{'new-item':NewPage<=1}" class="menu-item across-menu"><button @click="toStb('1')" class="menu-item-link" en>首页</button>
					 
					 </li>
					 <!-- 2-4 -->
					 <li  :class="{'new-item':NewPage<=4&&NewPage>1}" class="menu-item across-menu"><button @click="toStb('2')" class="menu-item-link">介绍</button> </li>
					 <!-- 5-9 -->
					 <li  :class="{'new-item':NewPage<=9&&NewPage>4}" class="menu-item across-menu"><button @click="toStb('3')" class="menu-item-link"><span en>1.</span>减少</button> </li>
					 <!-- 10 - 14 -->
					 <li  :class="{'new-item':NewPage<=14&&NewPage>9}" class="menu-item across-menu"><button @click="toStb('4')" class="menu-item-link"><span en>2.</span>创新</button> </li>
					 <!-- 15 -->
					 <li  :class="{'new-item':NewPage>14}" class="menu-item across-menu"><button @click="toStb('5')" class="menu-item-link"><span en>3.</span>保护</button> </li>
				 </ul>
		  </div>
		  <div class="top-icons" >
			  <!-- 搜素 、 发送邮件、 全屏 、下载 -->
			  <div class="navbar-minicart"  >
			  	<button  @click="toStb('9')" class="">
					<img :src="g+'/sousuo.png'" />
				</button>
			  </div>
			  	<!-- 发送邮件 -->
			  <!-- <div class="navbar-minicart float-left" v-if="$route.name=='sustainability'&&false"  >
			  	<button  @click="toStb('6')" class="navbar-trigger">发送</button>
			  </div> -->
			  <div class="navbar-minicart"  >
			  	<button  @click="toStb('7')" class="">
			  		<img src="@/assets/imgs/sustainability/quanpin.png" />
			  		<!-- <div style="height: 26px;line-height: 26px;">全屏</div> -->
			  	</button>
			  </div>
			  <div class="navbar-minicart" >
			  	<button @click="toStb('8')" class="">
			  		<!-- <img src="" /> -->
			  		<img  :src="g+'/pdf.png'" />
			  	</button>
			  </div>
		  </div>
	  </div>
	<div  ref="Vpage1" >
		<div ref="page1" class="page5 page1" :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}" >
			<div class="page5_mask page1_mask"  >
				<logo-img class="page1_mask_img" ></logo-img>
			</div>
			<video v-if="w>700" class="spread-bgVideo" :poster="g+'/download.jpg'" src="@/assets/video/1917685.mp4" :muted="true"  @loadedmetadata="loadVieo('video1')" ref="video1" loop  autoplay="autoplay" ></video>
			<img v-else src="@/assets/video/webp_1.gif" ref="video1" class="spread-bgVideo" />
		</div>
	</div>
	
	<div  ref="Vpage2" >
		<!-- :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" -->
		<div ref="page2" class="page2 " :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}" >
			<div class="page2_a" >
				<div>
					<div class="page2_jt" >«</div>
					<div class="page2_a_text" >
						<span en>Sisley</span>是一家法国家族企业，长期以来与环境和谐发展。我们的方针是有条不紊地行动，不断改进，在生产高品质美容产品的同时，减少对环境的影响。
					</div>
					<div class="page2_jt" ></div>
				</div>
				<div>
					<div class="page2_jt" ></div>
					<div  class="page2_a_text" >{{texts.page2_text2.text}}</div>
					<div class="page2_jt" >»</div>
				</div>
			</div>
			<div class="page2_b" >
				<div>
					- <span en>Philippe d'Ornano</span> 伯爵,<br>
					<span en>Sisley</span> 法国希思黎全球总裁
				</div>
			</div>
			<div @click="showTK('tk1')" class="incidentTitle" >
				<span class="incidentTitle_text" >{{texts.page2_text4.text}}</span>
				<skip-icon class="incidentTitle_icon" ></skip-icon>
			</div>
			<div>
				<!-- :style="{transform:'scale('+size+')'}" -->
				<div  @click="showTK('tk1')" class="incidentList"  >
					<div class="incidentList1" >
						<div class="incidentItem" >
							<img :data-src="g+'/utf-19.jpg'"  />
							<div en >2007</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/utf-6.jpg'"  />
							<div en >2011</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/AM4A7804_copie.jpg'"  />
							<div en >2015</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/utf-5.jpg'"  />
							<div en >2021</div>
						</div>
					</div>
					<div class="line" ></div>
					<div class="incidentList2" >
						<div class="incidentItem" >
							<img :data-src="g+'/utf-7.jpg'"  />
							<div en >1976</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/AM4A7597.jpg'"  />
							<div en >2009</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/utf-16.jpg'"  />
							<div en >2014</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/AM4A8334.jpg'"  />
							<div en >2019</div>
						</div>
						<div class="incidentItem" >
							<img :data-src="g+'/Film_de_Marque_LAB_3.jpg'"  />
							<div en >2022</div>
						</div>
					</div>
				</div>
			</div>
			<div class="page2_text5" >
				二十多年来，我们公司一直有条不紊地致力于减少对环境的影响：从原料采购到产品设计，再到整个生产过程。为此，<span en >Sisley</span>法国希思黎设立了专门的部门并聘请了外部顾问，同时得益于团队的积极性。通过指标来衡量我们所实施的行动的有效性，我们决心继续改善，推动目标的进一步实现。
			</div>
		</div>
	</div>
	<div  ref="Vpage3" >
		<div ref="page3" class="page3"  :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%','background-image': 'url('+g+'/1911474.jpg)'}:{'background-image': 'url('+g+'/1911474.jpg)'}" >
			<div class="page3_a nofullpage" >
				围绕三个优先领域，制定了一项涉及集团所有部门的 <span en>2025-2030</span> 年行动计划：
			</div>
			<div class="page3_b nofullpage" >
				<div>
					<div class="icon" >
						<img :data-src="g+'/280.png'" src="" />
					</div>
					<div class="title" ><span en>1.</span>{{texts.page3_text2.text}}</div>
					<div class="text" >
						<!---->
						<span class=" hover-bottom-line"  @click="scrollToRef('page6')"> {{texts.page3_text3.text}} </span>
						<!-- <span class=" hover-bottom-line"  @click="scrollToRef('page6')"></span> -->
					</div>
				</div>
				<div>
					<div class="icon" >
						<!-- <img :data-src="g+'/151.png'" src="" /> -->
						<innovate-icon></innovate-icon>
					</div>
					<div class="title" ><span en>2.</span>{{texts.page3_text4.text}}</div>
					<div class="text" >
						<span class=" hover-bottom-line"  @click="scrollToRef('page10')"> {{texts.page3_text5.text}} </span>
					</div>
				</div>
				<div>
					<div class="icon" >
						<!-- <img :data-src="g+'/421.png'" src="" /> -->
						<preserve-icon></preserve-icon>
					</div>
					<div class="title" ><span en>3.</span>{{texts.page3_text6.text}}</div>
					<div class="text" >
						<span class=" hover-bottom-line"  @click="scrollToRef('page15')"> {{texts.page3_text7.text}} </span>
					</div>
				</div>
			</div>
			<div class="page3_c nofullpage">
					<div class="page3_c_img"  >
						<img :data-src="g+'/utf-3.png'" />
					</div>
					<div class="page3_c_rigth">
						<div class="page3_c_titel" >
							<span en>Sisley</span> 致力于大自然
						</div>
						<div class="page3_c_text">
							除自身行动外，<span en>Sisley</span> 还通过各种计划支持世界各地的项目和协会，以保护环境、生物多样性和当地生态系统。
						</div>
						<div class="page3_c_btn">
							<div  @click="scrollToRef('page21')">{{texts.page3_text10.text}}</div>
						</div>
					</div>
			</div>
		</div>
	</div>
	<div  ref="Vpage4">
		<div ref="page4" class="page4 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem">
				<div class="lr_item" >
					<div class="page4_a">
						<div class="page4_a_1 " >
							<div class="q1 q" ></div>
							<div class="q2 q" ></div>
							<div class="q3 q" ></div>
							<div class="q4 q" ></div>
							<div class="q5 q" ></div>
							<div class="q6 q" ></div>
							<div class="q7 q" ></div>
							<div class="img1 icon"  @mouseover="onhover('page4','1')" >
								<!-- <img class="n" :data-src="g+'/151.png'" /> -->
								<!-- <img class="y" :data-src="g+'/439.png'" /> -->
								<shou-hua-icon class="n" ></shou-hua-icon>
								<shou-hua-icon class="y" type='2' ></shou-hua-icon>
							</div>
							<div class="img2 icon"  @mouseover="onhover('page4','2')" >
								<img class="n" :data-src="g+'/163.png'" />
								<img class="y" :data-src="g+'/158.png'" />
							</div>
							<div class="img3 icon"  @mouseover="onhover('page4','3')" >
								<img class="n" :data-src="g+'/178.png'" />
								<img class="y" :data-src="g+'/173.png'" />
							</div>
							<div class="img4 icon"  @mouseover="onhover('page4','4')" >
								<img class="n" :data-src="g+'/196.png'" />
								<img class="y" :data-src="g+'/188.png'" />
							</div>
							<div class="img5 icon"  @mouseover="onhover('page4','5')" >
								<!-- 212 220 -->
								<img class="n" :data-src="g+'/220.png'" />
								<img class="y" :data-src="g+'/212.png'" />
							</div>
							<div class="img6 icon" >
								<!--   -->
								<img  :data-src="g+'/Sisley_Environnement_Sustainability.png'" />
								
							</div>
							<div class="img7 icon"  @mouseover="onhover('page4','7')" >
								<img class="n" :data-src="g+'/243.png'" />
								<img class="y" :data-src="g+'/236.png'" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem">
				<div class="lr_item page4_b">
					<div class="page4_b_title1" >
						<div class="page4_b_title1_dot">●</div><span> {{texts.page4_text1.text}}</span>
					</div>
					<div class="page4_b_b" v-show="page4_type==5" >
						<div class="icon">
							<img :data-src="g+'/Colour_Formulas-Phyto-cosmetology.png'" />
							<div class="page4_b_text2" ><span class="page4_link" @click="scrollToRef('page11')" >更多信息</span>  </div>
						</div>
						<div>
							<div class="page4_texts">
								<div class="page4_b_title2" >{{texts.page4_text2.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text3.text}}</div>
							</div>
							
						</div>
					</div>
					<div class="page4_b_b" v-show="page4_type==7" >
						<div class="icon">
							<img :data-src="g+'/Colour_Energy-transportation.png'" />
							<div class="page4_b_text2" ><span class="page4_link" @click="scrollToRef('page9')" >更多信息</span>  </div>
						</div>
						<div>
							<div class="page4_texts">
								<div class="page4_b_title2" >{{texts.page4_text4.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text5.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text6.text}}</div>
							</div>
						</div>
					</div>
					<div class="page4_b_b" v-show="page4_type==4" >
						<div class="icon">
							<img :data-src="g+'/Colour_Our-sites.png'" />
							<div class="page4_b_text2" ><span class="page4_link" @click="scrollToRef('page6')" >更多信息</span>  </div>
						</div>
						<div >
							<div class="page4_texts" >
								<div class="page4_b_title2" >{{texts.page4_text7.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text8.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text9.text}}</div>
							</div>
						</div>
					</div>
					<div class="page4_b_b" v-show="page4_type==1" >
						<div class="icon">
							<img :data-src="g+'/Colour_Environmental-projects.png'" />
							<div class="page4_b_text2" ><span class="page4_link" @click="scrollToRef('page16')" >更多信息</span>  </div>
						</div>
						<div>
							<div class="page4_texts">
								<div class="page4_b_title2" >{{texts.page4_text10.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text11.text}}</div>
							</div>
						</div>
					</div>
					<div class="page4_b_b" v-show="page4_type==3" >
						<div class="icon">
							<img :data-src="g+'/Colour_Biodiversity.png'" />
							<div class="page4_b_text2" ><span class="page4_link" @click="scrollToRef('page18')" >更多信息</span>  </div>
						</div>
						<div>
							<div class="page4_texts">
								<div class="page4_b_title2" >{{texts.page4_text12.text}}</div>
								<div class="page4_b_text1" >{{texts.page4_text13.text}}</div>
							</div>
						</div>
					</div>
					<div class="page4_b_b" v-show="page4_type==2" >
						<div class="icon">
							<img :data-src="g+'/Colour_Packaging-eco-conception.png'" />
							<div class="page4_b_text2" ><span class="page4_link" @click="scrollToRef('page12')" >更多信息</span>  </div>
						</div>
						<div>
							<div class="page4_texts">
								<div class="page4_b_title2" >{{texts.page4_text14.text}}</div>
								<div class="page4_b_text1" >
									采用<span class="bold"  ><span en>4R</span>方法</span>：减少塑料重量、重复使用（填充物）、提高可回收性和回收材料的再利用。
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
	
	<div  ref="Vpage5" >
		<div ref="page5" class="page5" :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}" >
			<div class="page5_mask"  >
				<div class="page5_mask_text" >
					<div class="title2" >第一章</div>
					<div class="title" >减少</div>
					<div class="title2" >减少我们的活动对环境的影响</div>
					<div class="icon">
						<img :data-src="g+'/280.png'" />
					</div>
					<div class="text">
						<p>
							<span en>Sisley</span> 致力于在发展的同时减少对环境的影响。在能源、水、废物管理和物流领域，我们的团队每天都在努力减少其活动对环境的影响，并取得了持续和成功。根据 <span en>2019</span> 年进行的最新碳足迹评估数据，对各项行动进行衡量和监测。
						</p>
					</div>
				</div>
			</div>
			<video v-if="w>700" class="spread-bgVideo" :poster="g+'/cover.jpg'" src="@/assets/video/seq2.mov.mp4" :muted="true"  @loadedmetadata="loadVieo('video2')" ref="video2" loop  autoplay="autoplay" ></video>
			<img v-else src="@/assets/video/webp_4.gif" ref="video2" class="spread-bgVideo" />
		</div>
	</div>
	<div ref="Vpage6" >
		<div ref="page6" class="page6 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item "  >
					<div class="page6_left">
						<div class="icon" >
							<img :data-src="g+'/Colour_Our-sites.png'" />
						</div>
						<div class="title" >
							<p>我们的生产基地</p>
						</div>
						<div class="title2" >
							<p>{{texts.page6_text1.text}}</p>
						</div>
						<div class="text" >
							<p>
								<span en>Sisley</span> 在所有生产基地投入巨资，采用最新的隔热和节能技术。我们位于巴黎的总部以及位于瓦勒德瓦兹省（<span en>Val-d'Oise</span>）的圣旺-洛莫讷（<span en>Saint-Ouen l'Aumône</span>）研究、行政和物流基地均已获得高环境质量评价体系（<span en>HQE</span>）认证，该认证基于严格的方法（工作生活质量、负责任的管理、经济效益和对环境的尊重，包括合理利用资源和能源以及限制污染物排放）。
							</p>
							<p>与布洛瓦（<span en>Blois</span>）生产基地一样，圣旺-洛莫讷（<span en>Saint-Ouen l'Aumône</span>）物流基地也获得了<span en>ISO 14001</span>环境认证和 <span en>ISO 45001 </span>健康、卫生与安全认证。我们每个生产基地的设计都融入了景观和美学理念，旨在为员工提供明亮的工作环境。</p>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem  " >
				<div class="lr_item page6_right" >
					<div class="items" >
						<img :data-src="g+'/utf-12.jpg'" />
						<img :data-src="g+'/AM4A8322.jpg'" />
						<img :data-src="g+'/IMG_4198.jpg'" />
						<div class="tk1" >{{texts.page6_text4.text}}</div>
						<div class="tk2" >
							我们希望通过消费者的第一接触点--我们的精品零售店和<span en>Maison Sisley</span>法国希思黎之家参与进来，进一步推进这一理念。在每一家新店或现有店面的改造中，我们都会考虑到设备对生态环境的影响以及建筑的节能性能。
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage7" >
		<div ref="page7" class="page7 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class=" page7_left "  >
						<div class="icon" >
							<img :data-src="g+'/Colour_Our-sites.png'" />
						</div>
						<div class="title">能源消耗</div>
						<div class="title2" >
							最可持续的能源是我们不消耗的能源。因此，<span en>Sisley</span>法国希思黎采取了许多措施来减少工厂的能源消耗。
						</div>
						<div class="text">
							<p><span en>-25%</span>：这是我们自 <span en>2019</span> 年以来的能耗降幅，这要归功于我们在布洛瓦（<span en>Blois</span>）生产基地对更节能机器的投资（自动断电、循环工作......）、<span en>LED</span> 灯的安装、热调节以及对生产流程的审查（低温、加工时间、运行模式......）与此同时，产量增长了<span en> 28%</span>。</p>
							<p>我们正在采取大量行动，力争到 <span en>2025</span> 年将二氧化碳排放量（直接和间接）减少 <span en>20%</span>，到 <span en>2030</span> 年减少 <span>50%</span>（基准年：<span en>2019</span> 年）。为实现这一目标，我们特别致力于提高能源效率（优化工业流程、隔热和建筑管理等）和使用可再生能源。</p>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item"  >
					<div class="tk">
						<!-- texts.page7_text4.text -->
						因为 <span class="bold" >每一个举动都很重要</span>,我们每天都在现场采取行动, <span class="bold">以减少对环境的影响</span>; 在办公室安装照明存在探测器、在工作区安装 <span en>LED</span> 灯、减少夜间室外照明等。
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage8" >
		<div ref="page8" class="page8 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class=" page8_left"  >
						<div class="icon" >
							<img :data-src="g+'/Colour_Our-sites.png'" />
						</div>
						<div class="title">减少和回收废弃物</div>
						<div class="title2" >
							<span en>Sisley</span>在其生产基地采取了多项措施，以尽可能减少废物的产生，并通过合作伙伴优化废物的循环利用和回收。
						</div>
						<div class="text">
							<!-- texts.page8_text2.text  -->
							<p><span en>2022</span> 年，我们的废弃物比 <span en>2019</span> 年减少了 <span style="color: #47af78;"  en >14%</span> 超额完成了到 <span en>2025</span> 年每个销售单位减少 <span style="color: #47af78;" en >10%</span> 的目标。</p>
							<!-- texts.page8_text3.text -->
							<p>在法国的三个生产基地，<span style="color: #47af78;" en>79%</span> 的废弃物得到了回收利用，目标是到 <span en>2025</span> 年达到<span style="color: #47af78;" en >80%</span> ，<span style="color: #47af78;" en >100%</span>得到回收。 </p>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item page8_right" >
					<div class="tk">
						<!--texts.page8_text4.text-->
						 <span en >Sisley</span> 采取行动，从源头上减少废物（重复使用中间包装：气泡膜、纸板等），同时回收残余废物（回收广告材料等）。公司不断与服务供应商合作，创新并建立新的废物处理渠道（回收塑料、玻璃、标签材料等，包括我们生产工厂的污泥）。
						 <span en>Sisley</span> 采取行动， <span class="bold" >从源头上减少废物</span > （重复使用中间包装：气泡膜、纸板等），同时 <span class="bold" >回收残余废物</span> （回收广告材料等）。公司不断与服务供应商合作，创新并建立新的废物处理渠道（回收塑料、玻璃、标签材料等，包括我们生产工厂的污泥）。
					</div>
				</div>
			</div>
		</div>
	</div>
	<div ref="Vpage9" >
		<div ref="page9" class="page9 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class="page9_left">
						<div class="img">
							<img :data-src="g+'/AM4A7815_copie.jpg'"/>
						</div>
						<div class="tk" >
							<div class="icon">
								<img :data-src="g+'/Colour_Energy-transportation.png'"/>
							</div>
							<div class="title" >物流和运输</div>
							<div class="title2">由于 <span en>Sisley</span> 大部分产品都在法国生产，因此必须减少其在全球范围内的分销影响。</div>
							<div class="text" >
								<!-- texts.page9_text2.text -->
								<span style="color: #006fd3;" en >-52%</span>，这是自 <span en>2019</span> 年以来，由于我们与子公司携手开展的工作，与我们成品下游运输（空运和海运）相关的二氧化碳排放量减少了<span en> 52%</span>。
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item"  >
					<div class="page9_right">
						<div class="text">
							<!-- texts.page9_text3.text -->
							<p>作为一个向全球 <span en>100</span> 多个国家运输产品的国际品牌，我们一直面临着运输带来的影响。即使我们尽可能选择短途运输（<span style="color: #006fd3;" en > 80% </span> 以上的 <span en>Sisley</span> 产品在法国生产，我们的大部分零部件供应商、原材料和分包商都源自法国），但从我们的物流基地运输成品对我们的环境足迹影响最大（占 <span en>2019</span> 年二氧化碳排放量的 <span en>28%</span>）。</p>
							<!-- texts.page9_text4.text -->
							<p>经过十年减少空运的努力，现在我们的产品<span style="color: #006fd3;" en> 86% </span>通过海运，<span style="color: #006fd3;" en>14% </span>通过空运。此外，自 <span en>2006</span> 年起，<span en>Sisley</span> 增加了欧洲以外子公司的库存量，以继续尽可能避免空运，因为空运是造成 <span en>Sisley</span> 二氧化碳排放的主要因素之一。</p>
							<p>
								在减少空运的同时，<span en>Sisley</span> 还在尝试新的、更可持续的运输方式，如从法国到中国的铁路运输。集团还加入了 <span en>coZEV</span>（零排放船舶货主联盟），其目标是到 <span en>2040</span> 年实现零排放海运。
							</p>
						</div>
						<div class="tk" >
							<div class="img">
								<img :data-src="g+'/AM4A7377.jpg'" />
							</div>
							<div class="text" >
								{{texts.page9_text6.text}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div ref="Vpage10" >
		<div ref="page10" class="page5 page10" :poster="g+'/cover (1).jpg'" :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}" >
			<video v-if="w>700" class="spread-bgVideo"  :poster="g+'/cover (1).jpg'" src="@/assets/video/seq3.mov.mp4" :muted="true" loop  @loadedmetadata="loadVieo('video5')" ref="video5"  autoplay="autoplay" ></video>
			<img v-else src="@/assets/video/webp_3.gif" ref="video5" class="spread-bgVideo" />
			<div class="page5_mask"  >
				<div class="page5_mask_text" >
					<div class="title2" >第二章</div>
					<div class="title">创新</div>
					<div class="title2" >{{texts.page10_text1.text}}</div>
					<div class="icon">
						<!-- <img :data-src="g+'/151.png'" /> -->
						<div  style="transform:scale(2);transform-origin: 50% 0%">
							<innovate-icon ></innovate-icon>
						</div>
					</div>
					<div class="text" >
						<p>对于 <span en>Sisley</span>法国希思黎来说，无论是产品还是生产基地，环境与创新都是紧密相连的：将最好的自然与最先进的科学相结合，设计出安全有效的优质美容产品；采用生态设计标准重新定义包装和销售点广告材料；投资于更可持续的能源......</p>
					</div>
					<div class="btns" >
						<div @click="showTK('tk2')" class="my_btn" >
							<skip-icon class="btn-icon" type="2" ></skip-icon>
							<span class="btn-text" >集体活力</span>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
	<div ref="Vpage11" >
		<div ref="page11" class="page11 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class="page11_left">
						<div class="icon" >
							<img :data-src="g+'/Colour_Formulas-Phyto-cosmetology.png'" />
						</div>
						<div class="title">配方</div>
						<div class="title2">
							<span en>Sisley</span>实验室在研究和创新皮肤及其功能方面处于领先地位。
						</div>
						<div class="text">
							<p>{{texts.page11_text2.text}}</p>
							<p>{{texts.page11_text3.text}}</p>
						</div>
						<div class="btns" >
							<div @click="$router.push('/expertise-sisley')" class="my_btn" >我们的专业知识</div>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item">
					<div class="page11_right">
						<div class="img" >
							<img  :data-src="g+'/101.jpg'" />
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage12" >
		<div ref="page12" class="page12 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}"  >
			<div class="lr_Vitem" >
				<div class="lr_item"  >
					<div class="page12_left" >
						<div class="view">
							<div class="icon">
								<img :data-src="g+'/Colour_Packaging-eco-conception.png'" />
							</div>
							<div class="title">可持续产品设计</div>
							<div class="title2"><span en>Sisley</span> 有条不紊地设计出符合生态设计标准的高品质创新包装。</div>
							<div class="text">
								<!-- {{texts.page12_text2.text}} -->
								<p><span en >Sisley</span> 与其供应商合作，致力于改善产品包装、销售和运输包装对环境的影响。为此，在开发每种新包装解决方案时，都会使用 <span  en >SPICE</span> 生命周期分析工具测量其对环境的影响。</p>
								<p><span en>Sisley</span> 致力于减少塑料对环境的影响。在<span en>FEBEA</span>（法国化妆品企业协会）的框架内，公司参与了 “塑料法案”（<span en>Plastic Act</span>），这是一项具体的可持续化妆品包装共同行动计划，由 <span en>RE(SET)</span> 咨询公司围绕 <span en>4Rs</span> 制定：寻找合适的重量（减少）、可重复填充性、可回收性和使用可回收。</p>
							</div>
						</div>
						<div class="bottom" >
							<span class="c-hide" >某些</span>
							<div style="text-align: center;" class="a-hide b-hide" >某些例证</div>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item">
					<div  class="page12_right">
						<div class="view">
							<div class="page12_right_title right_title" >{{texts.page12_text4.text}}</div>
							<div class="view_item">
								<img class="item-left" :data-src="g+'/Phyto_Noir1985.png'" />
								<div class="item-right">
									<div class="page12_right_title">{{texts.page12_text5.text}}</div>
									<div>将包装中的塑料部分减少 <span en>20%</span></div>
								</div>
							</div>
							<div class="view_item">
								<img class="item-left" :data-src="g+'/Phyto_Noir1992_copy.png'" />
								<div class="item-right">
									<div class="page12_right_title">{{texts.page12_text7.text}}</div>
									<div>实现 <span en>100%</span> 可回收塑料的重复使用</div>
								</div>
							</div>
							<div class="view_item">
								<img class="item-left" :data-src="g+'/Phyto_Noir2042_copy.png'" />
								<div class="item-right">
									<div class="page12_right_title">{{texts.page12_text9.text}}</div>
									
									<div>到 <span en>2025</span> 年，回收利用 <span en>7</span> 种可重复填充的 <span en>Sisley</span> 新产品</div>
								</div>
							</div>
							<div class="view_item">
								<img class="item-left" :data-src="g+'/Phyto_Noir1963.png'" />
								<div class="item-right">
									<div class="page12_right_title">{{texts.page12_text11.text}}</div>
									<div>我们 <span en>20%</span> 的塑料包装，包装由回收塑料制成</div>
								</div>
							</div>
						</div>
						<div class="bottom" >
							<span class="c-hide">例证</span>
							<div style="text-align: center;" class="a-hide b-hide">某些例证</div>
							
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage13" >
		<div ref="page13" class="page13 lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class="img" >
						<img :data-src="g+'/102.jpg'" />
						<div class="view1" @click="toOutside('https://www.sisley.com.cn/detail?id=1417')" >
							<div class="title" en>{{texts.page13_text1.text}}</div>
							<div class="title2" >{{texts.page13_text2.text}}</div>
							<div class="text">{{texts.page13_text9.text}}</div>
						</div>
					</div>
					<div class="img">
						<img :data-src="g+'/103.jpg'" />
						<div class="view2" @click="toOutside('https://www.sisley.com.cn/detail?id=1153')">
							<div class="title" en>{{texts.page13_text3.text}}</div>
							<div class="title2" >魅惑水钻光唇膏是<span en>Sisley</span>第一款可续装的唇膏。笔芯采用更轻便的包装设计，以减少塑料的使用量，笔芯夹在瓶盖底部，可根据需要多次使用。</div>
							<div class="text">{{texts.page13_text9.text}}</div>
						</div>
					</div>
					
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class="img">
						<img :data-src="g+'/Phyto_Noir2013_copy.jpg'" />
						<div class="view3" @click="toOutside('https://www.sisley.com.cn/detail?id=990')" >
							<div class="title" en>{{texts.page13_text5.text}}</div>
							<div class="title2" >紧致美体精华乳是 <span en>Sisley</span> 第一款采用 <span en>100%</span> 再生材料（<span en>RPET</span> 塑料）制作瓶身的产品，也可回收再利用。</div>
							<div class="text">{{texts.page13_text9.text}}</div>
						</div>
					</div>
					<div class="img">
						<img :data-src="g+'/Phyto_Noir2032_copy.jpg'" />
						<div class="view4" @click="toOutside('https://www.sisley.com.cn/detail?id=381')" >
							<div class="title" en>{{texts.page13_text7.text}}</div>
							<div class="title2" >赋活丰盈喷雾瓶子的着色剂是为确保在分拣中心的可检测性而开发的。此外，它还是由 <span en>100%</span> 的可回收塑料制成，原料来自水瓶。</div>
							<div class="text">{{texts.page13_text9.text}}</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage14" >
		<div ref="page14" class="page14 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
			<div class="lr_Vitem" >
				<div class="lr_item">
					<div class="page14_left">
						<div class="icon">
							<img :data-src="g+'/Colour_Our-sites.png'" />
						</div>
						<div class="title">可再生能源</div>
						<div class="title2 bold">{{texts.page14_text1.text}}</div>
						<div class="text">
							<!-- texts.page14_text2.text -->
							<p>
								我们的物流基地（法国最大的物流基地之一，覆盖了基地办公室 <span class="bold" style="color: #47af78;" en>100%</span> 的能源消耗）一建成就安装了光伏屋顶。
							</p>
							<p>自 <span en>2021</span> 年起，我们的工业基地开始使用沼气，每年可节约近 <span en>850</span> 吨二氧化碳。</p>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item" >
					<div class="page14_right">
						<div class="item" >
							<img :data-src="g+'/utf-4.jpg'" />
							<div class="text">
								此外，从<span class="bold" > <span en>2024</span> 年起</span>，圣旺-洛莫讷（<span en>Saint-Ouen l'Aumône</span>）物流基地将安装地热能源，使该基地的二氧化碳排放量减少<span class="bold"  style="color: #47af78;" >-<span en>33%</span></span>（与传统能源相比）。
							</div>
						</div>
						<div  class="item">
							<img :data-src="g+'/AM4A7464.jpg'" />
							<div class="text" >{{texts.page14_text5.text}}</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage15" >
		<div ref="page15" class="page5 page15" :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}" >
			<div class="page5_mask"  >
				<div class="page5_mask_text" >
					<div class="title2" >第三章</div>
					<div class="title" >保护</div>
					<div class="title">自然资源</div>
					<div class="icon">
						<div class="icon_view" >
							<preserve-icon style="transform: scale(2); transform-origin: 0% 0%;"></preserve-icon>
						</div>
					</div>
					<div class="text">
						<p><span en>Sisley</span> 致力于保护自然资源，无论是在其生产基地、从植物和原材料中提取的活性成分的采购过程中，还是在与法国和全球社区的合作中。为此，我们采取了一系列具体行动。</p>
					</div>
				</div>
			</div>
			<video v-if="w>700" class="spread-bgVideo" :poster="g+'/cover (3).jpg'"  src="@/assets/video/seq5.mp4" :muted="true"  @loadedmetadata="loadVieo('video3')" ref="video3" loop  autoplay="autoplay" ></video>
			<img v-else src="@/assets/video/webp_2.gif" ref="video3" class="spread-bgVideo" />
		</div>
	</div>
	<div ref="Vpage16" >
		<div ref="page16" class="page16 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
					<div class="lr_Vitem" >
						<div class="lr_item">
							<div class="page16_left">
								<div class="icon">
									<img :data-src="g+'/Colour_Environmental-projects.png'" />
								</div>
								<div class="title">水资源利用</div>
								<div class="title2">为了保护自然资源，<span en>Sisley</span>团队正在努力减少生产基地和产品生产过程中的用水量。</div>
								<div class="text">
									<p>{{texts.page16_text2.text}}</p>
									<p>
										自 <span en>2019</span> 年以来，我们生产基地每生产一吨产品的耗水量减少了<span style="color: #a5cb68;" class="bold" en>28%</span>。
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="lr_Vitem" >
						<div class="lr_item" >
							<div class="page16_right">
								<div class="item" >
									<img :data-src="g+'/AM4A7600.jpg'" />
									<div class="text">
										<!-- texts.page16_text4.text -->
										同时，<span en>Sisley</span> 正在用更天然的替代品取代对环境或人类有风险的普通家用清洁产品。使用<span class="bold" en>CLEANEA</span><span class="bold">机器设备</span>，利用电解产生两种溶液，一种是消毒剂（<span en>H</span>+），另一种是脱脂剂（<span en>OH</span>-）。
									</div>
								</div>
								<div  class="item">
									<img :data-src="g+'/AM4A9178.jpg'" />
									<div class="text" >
										<p>
											<!-- texts.page16_text5.text -->
											此外，我们还在生产车间安装了一个<span class="bold">废水处理设备</span>，用于处理工业废水，限制对下游的水污染。
										</p>
										<p>经过 <span en>100%</span> 处理的水可去除部分污染，使其可以排放到自然环境中。</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
	</div>
	<div ref="Vpage17" >
		<div ref="page17" class="page17 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
					<div class="lr_Vitem" >
						<div class="lr_item">
							<div class="page17_left">
								<div class="icon">
									<img :data-src="g+'/Colour_Environmental-projects.png'" />
								</div>
								<div class="title">原材料</div>
								<div class="title2 bold">四十多年来，<span en>Sisley</span>法国希思黎的研究实验室一直专注于植物世界的研究。</div>
								<div class="text">
									<p>{{texts.page17_text2.text}}</p>
								</div>
								<div class="tk" >
									<div class="tk_title" >关注</div>
									<div class="tk_view" >
										<div class="tk_item" @click="showTK('tk3')">
											<img :data-src="g+'/utf-18.png'" />
											<div class="line" >{{texts.page17_text3.text}}</div>
										</div>
										<div class="tk_item" @click="showTK('tk4')" >
											<img :data-src="g+'/AM4A8998.png'" />
											<div>
												<div class="line">与供应商携手并进</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="lr_Vitem" >
						<div class="lr_item" >
							<div class="page17_right">
								<div class="item" >
									<img :data-src="g+'/utf-1.jpg'" />
									<!-- texts.page17_text5.text -->
									<div class="text">
										目前，我们的团队正在努力创建一个 <span class="bold"><span en>Sisley</span> 参照系统</span>，对以下六项标准进行测量和评估：天然性、碳足迹、社会和环境风险、环境安全性、对生物多样性的贡献以及可追溯性。我们的目标是在 <span en>2025</span> 年之前，根据这一基准分析我们的全部产品目录，以便对原材料对环境的影响进行仲裁和改进。
									</div>
								</div>
								<div  class="item">
									<img :data-src="g+'/utf-17.jpg'" />
									<!-- {exts.page17_text6.text -->
									<div class="text" >
									<span en>Sisley</span> <span class="bold">选择与我们有着同样关注的合作伙伴</span>：例如，参与棕榈油原料 <span en>RSPO</span> 认证（<span class=""  >可持续棕榈油圆桌会议</span>，认证可持续棕榈油生产，即经济上可行、生态上适当、社会上有益）和濒危物种保护的供应商。
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
	</div>
	<div ref="Vpage18" >
		<div ref="page18" class="page18 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
					<div class="lr_Vitem" >
						<div class="lr_item">
							<div class="page18_left">
								<div class="icon">
									<img :data-src="g+'/Colour_Biodiversity.png'" />
								</div>
								<div class="title">我们的场址中的生物多样性</div>
								<div class="text">
									<p class="text1">在法国，我们还开展了保护当地物种的活动：设置蜂箱、发展生态牧场、种植当地特有的植物品种，以及在我们的场所种植 <span en>4000</span> 棵树木和灌木等。</p>
									<p>{{texts.page18_text2.text}}</p>
								</div>
							</div>
						</div>
					</div>
					<div class="lr_Vitem" >
						<div class="lr_item" >
							<div class="page18_right">
								<div class="item" >
									<img :data-src="g+'/AM4A7389.jpg'" />
									<div class="text">{{texts.page18_text3.text}}</div>
								</div>
								<div  class="item">
									<img :data-src="g+'/utf-15.jpg'" />
									<div class="text" >{{texts.page18_text4.text}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
	</div>
	<div ref="Vpage19" >
		<div ref="page19" class="page19 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
					<div class="lr_Vitem" >
						<div class="lr_item">
							<div class="page19_left">
								<div class="title">致力于环保的</div>
								<div class="title2 t2"><span en>Sisley</span> 团队</div>
								<div class="title2 t3">员工日常参与</div>
								<div class="text">
									<p>我们在全球各地的 <span en>4900</span> 名员工积极行动起来，为促进良好的环保行为献计献策。</p>
									<p>{{texts.page19_text2.text}}</p>
									<p>此外，还采取了多项措施，支持 <span en>Sisley</span> 团队使用更可持续的交通方式：拼车、火车站和物流基地之间的轮换班车、电动车和混合动力车的电动终端......</p>
								</div>
							</div>
						</div>
					</div>
					<div class="lr_Vitem" >
						<div class="lr_item" >
							<div class="page19_right">
								<div class="img1 img" >
									<img  :data-src="g+'/1._IMG_1719.jpg'" />
								</div>
								<div class="img2 img" >
									<img :data-src="g+'/utf-8.png'" />
								</div>
								<div class="img3 img" >
									<img :data-src="g+'/utf-20.jpg'" />
								</div>
								<div class="img4 img" >
									<img :data-src="g+'/Capture.png'" />
								</div>
							</div>
						</div>
					</div>
				</div>
	</div>
	<div ref="Vpage20" >
		<div ref="page20" class="page20 lr" :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}" >
					<div class="lr_Vitem" >
						<div class="lr_item">
							<div class="page20_left">
								<div class="title" en>Sisley Tree Challenge</div>
								<div class="text">
									<!-- texts.page20_text1.text -->
									<p><span style="color:#a6cb66 ;" en>Sisley Tree Challenge</span> 是一项国际体育挑战赛，于 <span en>2022</span> 年首次诞生并启动，全球 <span en>33</span> 家 分公司齐聚一堂，共同支持环保事业。第一届活动旨在支持澳大利亚的植树造林工作，与 “种一棵树”（<span en>One Tree Planted</span>）公益环保组织合作种植了 <span en>78,000</span> 多棵树。</p>
									<p>在 <span en>2023</span> 年举办的第二届活动中，来自世界各地的 <span en>Sisley</span> 团队齐心协力，通过在墨西哥恢复红树林来保护生物多样性。红树林是一个拥有丰富生物多样性的生态系统，生长在海洋世界和陆地世界的交界处：其特殊性使其对保护海岸线和土壤、应对全球变暖、碳捕获以及珊瑚礁和海草床的健康至关重要。</p>
									<!-- texts.page20_text3.text -->
									<p><span en>2023</span> 年夏天，<span en>Sisley</span> 团队与<span >大自然保护协会</span>合作，在墨西哥普罗格雷索恢复了 <span en>60,000</span> 平方米的红树林。在开展这一环保项目的同时，还开展了一项社会活动，<span class="bold" >由墨西哥港口城市切莱姆的一群妇女组成的<span en>Las Chelemeras</span>领导，她们自<span en>2010</span>年以来一直致力于保护和恢复当地的红树林。</span></p>
								</div>
							</div>
						</div>
						<div class="shu shu1" >
							<shu-left-icon></shu-left-icon>
						</div>
					</div>
					<div class="lr_Vitem" >
						<div class="lr_item" >
							<div class="page20_right">
								<div class="page20_right_view">
									<div class="text">
										<!-- texts.page20_text4.text -->
										<p>这次挑战不仅对我和我的团队来说是一次很好的团队建设经历，而且也是一次学习经历，让我们认识到红树林对整个世界的重要性，以及红树林对整个环境的影响。更让我们大家感到惭愧的是，我们了解到 <span en>Las Chelemeras</span> 这群了不起的勇敢女性，她们通过在自己的社区做出巨大的改变，为所有人树立了榜样，证明了 “有志者事竟成”。感谢大家"。</p>
										<p class="bold" >- 路易斯-奥图扎尔（<span en>Luis Ortuzar</span>）--<span en>Sisley</span>法国希思黎墨西哥分公司总经理</p>
									</div>
									<div class="img1 img">
										<img :data-src="g+'/Poland_2.jpg'" />
									</div>
									<div class="img2 img">
										<img :data-src="g+'/Spain.jpg'" />
									</div>
									<div class="img3 img">
										<img :data-src="g+'/Netherlands.jpg'" />
									</div>
									<div class="img4 img">
										<img :data-src="g+'/France_-_Anastasia_Louis_Joseph.jpg'" />
									</div>
									<div class="img5 img">
										<img :data-src="g+'/South_Korea.png'" />
									</div>
									<div class="img6 img">
										<img :data-src="g+'/Czech_Rep.jpg'" />
									</div>
								</div>
							</div>
						</div>
						<div class="shu shu2" >
							<shu-right-icon></shu-right-icon>
						</div>
					</div>
				</div>
	</div>
	<div ref="Vpage21" style="background-color: #f8faec;" >
		<div ref="page21" class="page21"  :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}"  >
			<div class="page21_view" >
				<!-- <div class="title2">更进</div> -->
				<div class="title">更进一步</div>
				<div class="text">
				<!-- texts.page21_text1.text -->
				我们的主要目标是通过<span style="color: #3fa535;">减少活动产生的二氧化碳排放量来减少对环境的影响</span>。即使我们以最认真的态度和所有必要的严格要求来开展这项工作，也不可能完全实现碳中和，因为人类的所有活动都会产生影响。
				</div>
				<div class="img">
					<img :data-src="g+'/utf-3.png'" />
				</div>
				<!-- texts.page21_text2.text -->
				<div class="text">因此，我们于 <span en>2021</span> 年启动了 <span style="color: #3fa535;"><span en>Sisley</span> 自然计划</span>。每年，该计划都会支持和资助与当地居民合作的碳捕获和环境保护项目，以及支持生物多样性和尊重生态系统的措施。</div>
			</div>
		</div>
	</div>
	<div ref="Vpage22" style="background-color: #f8faec;">
		<div ref="page22" class="page22  lr " :style="{transform:'scale('+(size)+')','transform-origin': '0% 0%'}"  >
			<div class="lr_Vitem" >
				<div class="lr_item"  >
					<div class="page22_left">
						<div class="item-top title">{{texts.page22_text1.text}}</div>
						<div  class="item" >
							<img :data-src="g+'/utf-11.jpg'"  />
							<div class="text text1">
								<div class="title" >{{texts.page22_text2.text}}</div>
								<div class="page22_text" >森林是全球濒临灭绝的生态系统，是大量动植物的家园，必须加以保护。<span en>Sisley</span> 正在研究退化森林重建、植树造林和原始森林保护项目，并因此与法国国家林业局（<span en>ONF</span>）建立了合作伙伴关系。<span en>2022</span> 年，在受栗树病'墨汁'影响的几块栗树林被砍伐后，<span en>Sisley</span> 在法国国有森林（<span en>Forêt Domaniale de Fausses-Reposes</span>，<span en>92</span> 年）种植了 <span en>5,700</span> 多棵不同品种的树木（橡树、野樱桃等）。</div>
							</div>
						</div>
						<div  class="item " >
							<img :data-src="g+'/PNPC_000295.jpg'"  />
							<div class="text text2">
								<div class="title" >{{texts.page22_text4.text}}</div>
								<div class="page22_text" >自 <span en>2021</span> 年以来，<span en>Sisley</span> 一直是法国克罗斯港国家公园/ 波克罗勒岛国家公园的合作伙伴，致力于保护大洋海神草。大洋海神草是地中海盆地生物多样性的一个重要生态系统，也是一个真正的碳汇，但由于船只的潮湿而受到破坏。为此，我们为小学生编写了一本围绕 大洋海神草的教育活动手册，以提高他们对生物多样性、气候变化、污染和生态系统保护等问题的认识。</div>
							</div>
						</div>
						<div  class="item "  >
							<img :data-src="g+'/utf-13.jpg'"  />
							<div class="text text3">
								<div class="title" >{{texts.page22_text6.text}}</div>
								<div class="page22_text" ><span en>Sisley</span> 通过其基金会支持法国塞夫朗的农业高中这一创新项目，以具体和可持续的方式对初中和高中学生进行培训，让他们了解农业转型的挑战和未来生活各领域的职业：保护生物多样性、生产健康的本地食品、使农业和林业实践适应气候变化、树木在生产系统中的正确位置，甚至是传统与创新技术的结合。</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="lr_Vitem" >
				<div class="lr_item"  >
					<div class="page22_right">
						<div class="item-top title">{{texts.page22_text8.text}}</div>
						<div class="item"  >
							<img :data-src="g+'/utf-2.jpg'"  />
							<div class="text text4">
								<div class="title" >{{texts.page22_text9.text}}</div>
								<div class="page22_text" ><span en>Sisley</span> 及其基金会发起了一个创新项目：<span en>Fâro</span> 项目，旨在通过提高废物收集效率来减少塑料污染。该试点项目最初是与突尼斯可持续智能城市协会（<span en>MEGARA for Sustainable Smart Cities</span>）合作，在突尼斯的苏克拉（<span en>Soukra</span>）社区实施的。该项目以移动应用程序为基础，将所有参与垃圾收集的人员（住户、拾荒者、收集者）联系起来，通过当地的回收渠道，大幅增加塑料的回收量。该项目的预期目标，除了通过使用数字工具进行创新外，还具有社会性质，因为它将参与者重新纳入正规渠道。它将被用于其他受到塑料污染困扰的地区。</div>
							</div>
						</div>
						<div class="item" >
							<img :data-src="g+'/utf-14.jpg'"  />
							<div class="text text5">
								<div class="title" >{{texts.page22_text11.text}}</div>
								<div class="page22_text" >自 <span en>2017</span> 年以来，<span en>Sisley-d'Ornano</span>多纳诺基金会会一直为非政府组织 <span en>Noé</span> 提供支持，该组织的目标是在生物多样性受到威胁的地区保护和恢复生物多样性。继 <span en>2019</span> 年在喀麦隆德贾 自然生物保护区的热带森林提供初步支持后，自 <span en>2022</span> 年起，基金会通过部署负责任的部门和推广喀麦隆有机优质林业和农林产品，支持在喀麦隆贝努埃国家公园外围开发社区可持续管理项目。</div>
								<div class="page22_text" >该项目是协会长期承诺的一部分，协会已在喀麦隆培训了 <span en>470</span> 多名妇女，保护了 <span en>4000</span> 多公顷的森林。</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
		</div>
	</div>
	<div ref="Vpage23" >
		<div ref="page23" class="page5 page1 page23" :style="w<=960?{transform:'scale('+(w/960)+')','transform-origin': '0% 0%'}:{}" >
			<div class="page5_mask page1_mask"  >
				<logo-img class="page1_mask_img" ></logo-img>
			</div>
			<video v-if="w>750" class="spread-bgVideo" :poster="g+'/cover.jpg'" @loadedmetadata="loadVieo('video4')"  src="@/assets/video/seq2.mov.mp4" :muted="true" ref="video4" loop  autoplay="autoplay" ></video>
			<img v-else src="@/assets/video/webp_4.gif" ref="video4" class="spread-bgVideo" />
		</div>
	</div>
	
	<!-- 事件表 -->
	<div class="Vtk1" v-if="isShow.tk1" >
		<div class="tk1" >
			<div class="top" >
				<span class="btn" @click="hideTK('tk1')" >关闭</span>
			</div>
			<div class="view"  >
			<div ref="tk1_V">
				<div class="list" ref="tk1_view" :style="{transform:'scale('+((w<960?w:960)/960)+')','transform-origin': '0% 0%'}" >
					<!-- tk1_text1 -->
					<div class="item" >
						<div class="date" en>1976</div>
						<div class="text">创建 <span en>Sisley</span>法国希思黎，成为植物美容领域的先驱</div>
						<div class="img">
							<img :src="g+'/20241101_1.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2003</div>
						<div class="text">收购位于布洛瓦（<span en>Blois</span>）的 <span en>Francos</span> 工厂，并投资对其进行现代化改造，特别是在能源效率方面</div>
						<div class="img">
							<img :src="g+'/AM4A8281.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2007</div>
						<div class="text">创建 <span>Sisley</span>-多纳诺基金会，其主要承诺之一是支持环保</div>
						<div class="img">
							<img :src="g+'/1662535868178_(1).jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2009</div>
						<div class="text bold">{{texts.tk1_text4.text}}</div>
						<div class="img">
							<img :src="g+'/AM4A7597.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2011</div>
						<div class="text">
							<p>收购圣旺-洛莫讷（<span en>Saint-Ouen l'Aumône</span>）物流基地，并在法国建造了首个获得高环境质量评价体系（<span en>HQE</span>）认证的仓库。</p>
							<p>{{texts.tk1_text6.text}}</p>
						</div>
						<div class="img">
							<img :src="g+'/AM4A7447_(1).jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2014</div>
						<div class="text">法国生产基地首次获得环境、健康、卫生与安全（<span en>ISO 14001</span> 和 <span en>45001</span>）</div>
						<div class="img">
							<img :src="g+'/AM4A7532_(1).jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2015</div>
						<div class="text">在圣旺-洛莫讷（<span en>Saint-Ouen l'Aumône</span>）工厂进行首次能源审计。然后在 <span en>2023</span> 年对布洛瓦（<span en>Blois</span>）生产场地进行能源审计。</div>
						<div class="img">
							<img :src="g+'/AM4A7804_copie.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2017</div>
						<div class="text">巴黎新总部通过 <span en>HQE</span> 认证</div>
						<div class="img">
							<img :src="g+'/IMG_3103_retouche2.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2019</div>
						<div class="text">
							<!-- <p class="bold">第二次企业社会责任审计和《<span en>2020-2030</span>行动计划》</p> -->
							<p>{{texts.tk1_text11.text}}</p>
						</div>
						<div class="img">
							<img :src="g+'/AM4A8334_2.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2021</div>
						<div class="text">第二次企业社会责任审计和 <span en>2020-2030</span> 年行动计划 为保护生物多样性</div>
						<div class="img">
							<img :src="g+'/Progreso_17_(6).jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2021</div>
						<div class="text">制定了 “<span en>Sisley for nature</span> ”计划 最终确定了十年行动计划，将布洛瓦（<span en>Blois</span>）每个产品的能耗降低<span en>50%</span></div>
						<div class="img">
							<img :src="g+'/AM4A9080.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date" en>2022</div>
						<div class="text">{{texts.tk1_text14.text}}</div>
						<div class="img">
							<img :src="g+'/AM4A8233.jpg'" />
						</div>
					</div>
					<div class="item" >
						<div class="date date2" >
							<div class="date_text">{{texts.tk1_text16.text}}</div>
							<div class="date_num" en>2022</div>
						</div>
						<div class="text">与化妆品行业的其他企业共同制定环保方针（<span en>Eco-Beauty Score Consortium</span>联盟）。</div>
						<div class="img">
							<img :src="g+'/Film_de_Marque_LAB_3.jpg'" />
						</div>
					</div>
					
				</div>
			</div>
			</div>
		</div>
	</div>
	<!-- 集体活力 弹框 -->
	<div class="Vtk2 Vtk1" v-if="isShow.tk2" >
		<div class="tk2 tk1" >
			<div class="top" >
				<span class="btn" @click="hideTK('tk2')" >关闭</span>
			</div>
			<div class="view">
				<div class="img_view" >
					<img :src="g+'/tk2_1.jpg'" />
					<div :style="{transform:'scale('+((w<960?w:960)/960)+')','transform-origin': '50% 50%'}" class="tk2_tk">
						<div class="title">集体活力</div>
						<div class="text"><span en>Sisley</span> 加入了多个行业倡议，以进一步推进其项目。其中，“纸浆行动 ”倡议得到了<span en>RE(SET)</span> 商业环保战略咨询公司和其他化妆品品牌的支持，旨在开发一种基于纤维素纤维的包装解决方案。<span en>Sisley</span> 还是<span en>Eco-Beauty Score Consortium</span>联盟的成员，该联盟由国际化妆品行业的 <span en>60</span> 多家公司联合发起，旨在对化妆品产品进行共同的环境保护展示。</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="Vtk3 Vtk" v-if="isShow.tk3" >
		<div class="tk3" >
			<div class="top" >
				<span class="btn" @click="hideTK('tk3')" >关闭</span>
			</div>
			<div class="view">
				<div class="" ref="tk3_V" >
					<div ref="tk3_view" class="tk3_view" :style="{transform:'scale('+((w<1500?w:1500)/1500)+')','transform-origin': '0% 0%'}">
						<div>
							<div class="logo_view" >
								<img  :src="g+'/Colour_Environmental-projects.png'" />
							</div>
							<div class="title2">关注</div>
							<div class="title">副产品的回收和植物废弃物的循环利用</div>
							<div class="list">
								<div class="item">
									<div class="item_img_view">
										<img :src="g+'/tk3_1.jpg'" />
									</div>
									<div class="item_texts">
										<div class="item_title">藏红花</div>
										<div class="text">
											<p>藏红花提取物 <span en>Sisley</span>参与了其他行业副产品的价值评估。藏红花提取物就是这样一种食品工业的副产品，它是藏红花系列的标志性活性成分。<span en>Sisley</span> 研究所选择的藏红花是与植物提取专家合作的成果。它生长在法国中部利穆赞区的中心地带，土壤特别肥沃，来自法国的手工藏红花种植者。</p>
											<p>藏红花是唯一 一种来自花朵的香料。藏红花的花朵在清晨由人工采摘。花朵采摘后，要进行修剪，以回收产生香料的雌蕊。作为废物回收过程的一部分，通常会被扔掉的花瓣也会被回收，因为它们含有丰富的活性分子。</p>
										</div>
									</div>
								</div>
								<div class="item">
									<div class="item_img_view">
										<img :src="g+'/tk3_2.png'" />
									</div>
									<div class="item_texts">
										<div class="item_title">小麦提取物</div>
										<div class="text">
											<p>某些植物活性成分在生产过程中会产生废弃物，而这些废弃物可以被其他行业回收利用。例如，单粒小麦提取物就是这种情况。来自有机农场的小麦提取物是通过酶水解工艺获得的。这是一种清洁工艺，不使用溶剂，在低温下进行，因此非常节能。</p>
											<p>萃取过程中产生的植物废料会在当地农场回收，用作动物的食物。</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div class="Vtk4 Vtk" v-if="isShow.tk4" >
		<div class="tk4" >
			<div class="top" >
				<span class="btn" @click="hideTK('tk4')" >关闭</span>
			</div>
			<div class="view">
				<div class="" ref="tk4_V" >
					<div ref="tk4_view" class="tk4_view" :style="{transform:'scale('+((w<1500?w:1500)/1500)+')','transform-origin': '0% 0%'}">
						<div>
							<div class="logo_view" >
								<img  :src="g+'/Colour_Environmental-projects.png'" />
							</div>
							<div class="title2">关注</div>
							<div class="title">与供应商携手并进</div>
							<div class="text"><span en>Sisley</span> 在整个价值链中奉行负责任的采购政策。因此，供应商是我们项目的核心。我们每年都会与供应商进行沟通，目的是不断改进社会、环境和道德标准（<span en>Ecovadis</span> 公司管理工具和内部或外部审计），并在其中一项标准未得到遵守时启动纠正计划。</div>
							<div class="list">
								<div class="item">
									<div class="item_img_view">
										<img :src="g+'/AM4A8998.jpg'" />
									</div>
									<div class="item_texts">
										<div class="item_title" style="text-transform: uppercase" >当地关系</div>
										<div class="item_text">
											<p>我们 <span en>70%</span> 的生产采购供应商（零部件、原材料和分包商）都来自法国。</p>
										</div>
									</div>
								</div>
								<div class="item">
									<div class="item_img_view">
										<img :src="g+'/AM4A8762_(1).jpg'" />
									</div>
									<div class="item_texts">
										<div class="item_title">长期合作关系</div>
										<div class="item_text">
											<p>我们与<span en> 69%</span> 的战略供应商建立了超过 <span en>10</span> 年的商业关系，其中 <span en>30%</span> 甚至超过 <span en>20</span> 年。</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="Vtk5 Vtk" v-if="isShow.tk5" >
		<div class="tk5" >
			<div class="top" >
				          <div class="search_input_box">
							  <div class="search_input">
							    <i class="iconfont select-all">&#xe60e;</i>
							    <input
							          class="form-control search-field"
							          type="text"
							          name="q"
							          v-model.trim="keyWords"
									  @input="getTextPage"
							          placeholder=""
							          autocomplete="off"
							        />
							    <i v-if="keyWords" class="iconfont clsose_dialog clearKeywordMin select-all" @click="keyWords=''">&#xe615;</i>
							    
							  </div>
						  </div>
				<span class="btn" @click="hideTK('tk5')" >关闭</span>
			</div>
			<div class="view" v-if="textPageList.length>0">
				<div class="title"><span en>{{textPageList.length}}</span>条</div>
				<ul class="list">
					<li @click="keyWordsToPage(item)" class="item" v-for="item in textPageList">
						<div class="item_title" en>{{item.title}}</div>
						<div class="item_text">{{item.text}}</div>
					</li>
				</ul>
			</div>
			<div class="view">
				<div class="nullList" >暂无结果</div>
			</div>
		</div>
	</div>
	<div class="Vtk6 Vtk"  @click="hideTK('tk6')" v-if="isShow.tk6" >
		<div class="tk6"  @click.stop>
			<div class="top" >
				<i  class="iconfont clsose_dialog"  @click="hideTK('tk6')">&#xe615;</i>
			</div>
			<div class="view" >
				<ul class="menu-list">
									 <!-- 1 -->
									 <li class="menu-item " @click="toStb('1')" >首页</li>
									 <!-- 2-4 -->
									 <li  class="menu-item " @click="toStb('2')" >介绍 </li>
									 <!-- 5-9 -->
									 <li   class="menu-item " @click="toStb('3')" ><span en>1.</span>减少 </li>
									 <!-- 10 - 14 -->
									 <li  class="menu-item " @click="toStb('4')"><span en>2.</span>创新</li>
									 <!-- 15 -->
									 <li  class="menu-item " @click="toStb('5')" ><span en>3.</span>保护</li>
				</ul>
				
			</div>
			
		</div>
	</div>
	<!-- <div class="page24" ></div> -->
	
  </div>
</template>

<script>
import api from "@/utils/api";
import types from "@/store/types";
import utils from "@/utils";
import logoImg from "./img/logoImg.vue";
import skipIcon from "./img/skip-icon.vue";
import innovateIcon from "./img/innovate-icon.vue";
import preserveIcon from "./img/preserve-icon.vue";
import shouHuaIcon from "./img/shou-hua-icon.vue"
import shuLeftIcon from "./img/shu-left-icon.vue";
import shuRightIcon from "./img/shu-right-icon.vue";


export default {
  name: "sustainability",
  components: {
	  // 动画组件
	  // InTextAnimate: () => import('@/components/InTextAnimate'),
	  logoImg,
	  skipIcon,
	  innovateIcon,
	  preserveIcon,
	  shouHuaIcon,
	  shuRightIcon,
	  shuLeftIcon
  },
  watch:{
	  '$store.state.sustainabilityPath'(item){
		  //1 2 3 4
		  if(item.type==1){
			  this.scrollToRef('page1')
		  }else if(item.type==2){
			  this.scrollToRef('page2')
		  }else if(item.type==3){
			  this.scrollToRef('page5')
		  }else if(item.type==4){
			  this.scrollToRef('page10')
		  }else if(item.type==5){
			  this.scrollToRef('page15')
		  }else if(item.type==6){
			  // 邮箱
			  // this.fx()
		  }else if(item.type==7){
			  // 全屏
			  this.qp()
		  }else if(item.type==8){
			  // pdf
			  this.toOutside(this.baseUel+'file/sustainability_2.pdf')
		  }else if(item.type==9){
			  // 搜索
			  this.showTK('tk5')
		  }
	  	console.log(item,this.$store.state.sustainabilityPath)
	  }
  },
  data() {
	  let g=process.env.VUE_APP_BASE_URL+'sustainability'
	  let _this=this;
    return {
		baseUel:process.env.VUE_APP_BASE_URL,
		g:g,
		// 定时器
		isLoadSizeDs:null,
		size:1,
		w:document.documentElement.clientWidth,
		// 固定//可能的搜索条件
		texts:{
			
			page2_text1:{title:'page2',name:'xx',text:'Sisley是一家法国家族企业，长期以来与环境和谐发展。我们的方针是有条不紊地行动，不断改进，在生产高品质美容产品的同时，减少对环境的影响。',html:`<span en >Sisley</span>是一家法国家族企业，长期以来与环境和谐发展。我们的方针是有条不紊地行动，不断改进，在生产高品质美容产品的同时，减少对环境的影响。`},
			page2_text2:{title:'page2',name:'xx',text:'我们以务实和一贯的态度，寻求与社区建立长期合作关系，并关爱所有与我们互动的人。',
			
			},
			page2_text3:{title:'page2',name:'xx',text:"-- Sisley法国希思黎全球总裁Philippe d'Ornano伯爵",},
			page2_text4:{title:'page2',name:'xx',text:'里程碑'},
			page2_text5:{title:'page2',name:'xx',text:'二十多年来，我们公司一直有条不紊地致力于减少对环境的影响：从原料采购到产品设计，再到整个生产过程。为此，Sisley法国希思黎设立了专门的部门并聘请了外部顾问，同时得益于团队的积极性。通过指标来衡量我们所实施的行动的有效性，我们决心继续改善，推动目标的进一步实现。'},
			// -----
			page3_text1:{title:'page3',name:'xx',text:'围绕三个优先领域，制定了一项涉及集团所有部门的 2025-2030 年行动计划：'},
			page3_text2:{title:'page3',name:'xx',text:'减少',},
			page3_text3:{title:'page3',name:'xx',text:'减少我们活动的环境足迹'},
			page3_text4:{title:'page3',name:'xx',text:'创新'},
			page3_text5:{title:'page3',name:'xx',text:'负责任地进行可持续创新'},
			page3_text6:{title:'page3',name:'xx',text:'保护'},
			page3_text7:{title:'page3',name:'xx',text:'保护我们的自然资源'},
			page3_text8:{title:'page3',name:'xx',text:'Sisley 致力于大自然',},
			page3_text9:{title:'page3',name:'xx',text:'除自身行动外，Sisley 还通过各种计划支持世界各地的项目和协会，以保护环境、生物多样性和当地生态系统。'},
			page3_text10:{title:'page3',name:'xx',text:'了解更多'},
			
			page4_text1:{title:'page4',name:'xx',text:'点击图标了解我们的行动举措'},//0
			page4_text2:{title:'page4',name:'xx',text:'配方与植物美容学'}, 
			page4_text3:{title:'page4',name:'xx',text:'将大自然的精华与最先进的科学相结合，设计出优质、安全、有效的美容产品。同时致力于提高原材料的可持续。'},
			page4_text4:{title:'page4',name:'xx',text:'能源与运输'},
			page4_text5:{title:'page4',name:'xx',text:'减少与能源消耗和上下游运输相关的二氧化碳排放量。'},
			page4_text6:{title:'page4',name:'xx',text:'减少、循环利用和回收废物。'},
			page4_text7:{title:'page4',name:'xx',text:'选址'},
			page4_text8:{title:'page4',name:'xx',text:'优先使用可再生能源：沼气、地热、光伏。'},
			page4_text9:{title:'page4',name:'xx',text:'确保为我们的团队提供高质量的工作环境。'},
			page4_text10:{title:'page4',name:'xx',text:'自然资源'},
			page4_text11:{title:'page4',name:'xx',text:'减少用水量（工艺、配方等），避免土壤污染。'},
			page4_text12:{title:'page4',name:'xx',text:'生物多样性'},
			page4_text13:{title:'page4',name:'xx',text:'保护我们生产基地周围的生态系统（种植树木和灌木、晚割草、生态种植、蜂箱等）。'},
			page4_text14:{title:'page4',name:'xx',text:'包装与可持续产品设计'},
			page4_text15:{title:'page4',name:'xx',text:'采用 4R 方法：减少塑料重量、重复使用（填充物）、提高可回收性和回收材料的再利用。',},
			
			page5_text1:{title:'page5',name:'xx',text:'Sisley 致力于在发展的同时减少对环境的影响。在能源、水、废物管理和物流领域，我们的团队每天都在努力减少其活动对环境的影响，并取得了持续和成功。根据 2019 年进行的最新碳足迹评估数据，对各项行动进行衡量和监测。'},
			page6_text1:{title:'page6',name:'xx',text:'作为一家家族企业，我们可以规划长期投资，并通过雄心勃勃的可持续发展项目减少对环境的影响。'},
			page6_text2:{title:'page6',name:'xx',text:"Sisley 在所有生产基地投入巨资，采用最新的隔热和节能技术。我们位于巴黎的总部以及位于瓦勒德瓦兹省（Val-d'Oise）的圣旺-洛莫讷（Saint-Ouen l'Aumône）研究、行政和物流基地均已获得高环境质量评价体系（HQE）认证，该认证基于严格的方法（工作生活质量、负责任的管理、经济效益和对环境的尊重，包括合理利用资源和能源以及限制污染物排放）。"},
			page6_text3:{title:'page6',name:'xx',text:"与布洛瓦（Blois）生产基地一样，圣旺-洛莫讷（Saint-Ouen l'Aumône）物流基地也获得了ISO 14001环境认证和 ISO 45001 健康、卫生与安全认证。我们每个生产基地的设计都融入了景观和美学理念，旨在为员工提供明亮的工作环境。"},
			page6_text4:{title:'page6',name:'xx',text:'在公司不断发展壮大和招贤纳士之际，我们正在计划扩建生产和物流基地。这些项目采用了全面的高环境质量方法。我们还将继续监测和整合新技术，以减少对环境的影响。'},
			page6_text5:{title:'page6',name:'xx',text:'我们希望通过消费者的第一接触点--我们的精品零售店和Maison Sisley法国希思黎之家参与进来，进一步推进这一理念。在每一家新店或现有店面的改造中，我们都会考虑到设备对生态环境的影响以及建筑的节能性能。'},
			
			page7_text1:{title:'page7',name:'xx',text:'最可持续的能源是我们不消耗的能源。因此，Sisley法国希思黎采取了许多措施来减少工厂的能源消耗。'},
			page7_text2:{title:'page7',name:'xx',text:'-25%：这是我们自 2019 年以来的能耗降幅，这要归功于我们在布洛瓦（Blois）生产基地对更节能机器的投资（自动断电、循环工作......）、LED 灯的安装、热调节以及对生产流程的审查（低温、加工时间、运行模式......）与此同时，产量增长了 28%。'},
			page7_text3:{title:'page7',name:'xx',text:'我们正在采取大量行动，力争到 2025 年将二氧化碳排放量（直接和间接）减少 20%，到 2030 年减少 50%（基准年：2019 年）。为实现这一目标，我们特别致力于提高能源效率（优化工业流程、隔热和建筑管理等）和使用可再生能源。'},
			page7_text4:{title:'page7',name:'xx',text:'因为每一个举动都很重要，我们每天都在现场采取行动，以减少对环境的影响：在办公室安装照明存在探测器、在工作区安装 LED 灯、减少夜间室外照明等。'},
			
			page8_text1:{title:'page8',name:'xx',text:'Sisley在其生产基地采取了多项措施，以尽可能减少废物的产生，并通过合作伙伴优化废物的循环利用和回收。'},
			page8_text2:{title:'page8',name:'xx',text:'2022 年，我们的废弃物比 2019 年减少了 14%，超额完成了到 2025 年每个销售单位减少 10% 的目标。'},
			page8_text3:{title:'page8',name:'xx',text:'在法国的三个生产基地，79% 的废弃物得到了回收利用，目标是到 2025 年达到 80%，100% 得到回收。'},
			page8_text4:{title:'page8',name:'xx',text:'Sisley 采取行动，从源头上减少废物（重复使用中间包装：气泡膜、纸板等），同时回收残余废物（回收广告材料等）。公司不断与服务供应商合作，创新并建立新的废物处理渠道（回收塑料、玻璃、标签材料等，包括我们生产工厂的污泥）'},
			
			page9_text1:{title:'page9',name:'xx',text:'由于 Sisley 大部分产品都在法国生产，因此必须减少其在全球范围内的分销影响。'},
			page9_text2:{title:'page9',name:'xx',text:'-52%，这是自 2019 年以来，由于我们与子公司携手开展的工作，与我们成品下游运输（空运和海运）相关的二氧化碳排放量减少了 52%。'},
			page9_text3:{title:'page9',name:'xx',text:'作为一个向全球 100 多个国家运输产品的国际品牌，我们一直面临着运输带来的影响。即使我们尽可能选择短途运输（80% 以上的 Sisley 产品在法国生产，我们的大部分零部件供应商、原材料和分包商都源自法国），但从我们的物流基地运输成品对我们的环境足迹影响最大（占 2019 年二氧化碳排放量的 28%）。'},
			page9_text4:{title:'page9',name:'xx',text:'经过十年减少空运的努力，现在我们的产品 86% 通过海运，14% 通过空运。此外，自 2006 年起，Sisley 增加了欧洲以外子公司的库存量，以继续尽可能避免空运，因为空运是造成 Sisley 二氧化碳排放的主要因素之一。'},
			page9_text5:{title:'page9',name:'xx',text:'在减少空运的同时，Sisley 还在尝试新的、更可持续的运输方式，如从法国到中国的铁路运输。集团还加入了 coZEV（零排放船舶货主联盟），其目标是到 2040 年实现零排放海运。'},
			page9_text6:{title:'page9',name:'xx',text:'我们为各工作地点配备了充电站，以鼓励人们购买混合动力车或电动车，并建立了视频会议系统，以尽量减少各工作地点之间的交通。'},
			
			page10_text1:{title:'page10',name:'xx',text:' 以可持续和负责任的方式进行创新'},
			page10_text2:{title:'page10',name:'xx',text:' 对于 Sisley法国希思黎来说，无论是产品还是生产基地，环境与创新都是紧密相连的：将最好的自然与最先进的科学相结合，设计出安全有效的优质美容产品；采用生态设计标准重新定义包装和销售点广告材料；投资于更可持续的能源...... '},
			
			page11_text1:{title:'page11',name:'xx',text:'Sisley实验室在研究和创新皮肤及其功能方面处于领先地位。'},
			page11_text2:{title:'page11',name:'xx',text:'数年来，这些公司在选择原料时一直考虑其对环境的影响，并设计出越来越符合我们环保目标的配方。'},
			page11_text3:{title:'page11',name:'xx',text:'为加强环境安全评估方面的专业知识，我们进行了大量投资。'},
			
			page12_text1:{title:'page12',name:'xx',text:'Sisley 有条不紊地设计出符合生态设计标准的高品质创新包装。'},
			page12_text2:{title:'page12',name:'xx',text:'Sisley 与其供应商合作，致力于改善产品包装、销售和运输包装对环境的影响。为此，在开发每种新包装解决方案时，都会使用 SPICE 生命周期分析工具测量其对环境的影响。'},
			page12_text3:{title:'page12',name:'xx',text:'Sisley 致力于减少塑料对环境的影响。在FEBEA（法国化妆品企业协会）的框架内，公司参与了 “塑料法案”（Plastic Act），这是一项具体的可持续化妆品包装共同行动计划，由 RE(SET) 咨询公司围绕 4Rs 制定：寻找合适的重量（减少）、可重复填充性、可回收性和使用可回收。'},
			page12_text4:{title:'page12',name:'xx',text:'到 2025 年... '},
			page12_text5:{title:'page12',name:'xx',text:'减少'},
			page12_text6:{title:'page12',name:'xx',text:'将包装中的塑料部分减少 20 %'},
			page12_text7:{title:'page12',name:'xx',text:'重复利用'},
			page12_text8:{title:'page12',name:'xx',text:'到 2025 年，回收利用 7 种可重复填充的 Sisley 新产品'},
			page12_text9:{title:'page12',name:'xx',text:'循环利用'},
			page12_text10:{title:'page12',name:'xx',text:'实现 100% 可回收塑料的重复使用'},
			page12_text11:{title:'page12',name:'xx',text:'回收利用 '},
			page12_text12:{title:'page12',name:'xx',text:'我们 20% 的塑料包装，包装由回收塑料制成'},
			
			page13_text1:{title:'page13',name:'xx',text:'ALL DAY ALL YEAR'},
			page13_text2:{title:'page13',name:'xx',text:'日间防护精华乳采用全新的真空包装，玻璃罐内部为装满精华的内袋，随着使用而压缩。使用完毕后，可以分解压头、内袋和玻璃瓶。可以有效回收利用，永续环保理念。'},
			page13_text3:{title:'page13',name:'xx',text:'PHYTO-ROUGE SHINE'},
			page13_text4:{title:'page13',name:'xx',text:'魅惑水钻光唇膏是Sisley第一款可续装的唇膏。笔芯采用更轻便的包装设计，以减少塑料的使用量，笔芯夹在瓶盖底部，可根据需要多次使用。'},
			page13_text5:{title:'page13',name:'xx',text:'LE SCULPTEUR'},
			page13_text6:{title:'page13',name:'xx',text:'紧致美体精华乳是 Sisley 第一款采用 100% 再生材料（RPET 塑料）制作瓶身的产品，也可回收再利用。'},
			
			page13_text7:{title:'page13',name:'xx',text:' HAIR RITUEL BY SISLEY VOLUMIZING SPRAY'},
			page13_text8:{title:'page13',name:'xx',text:'赋活丰盈喷雾瓶子的着色剂是为确保在分拣中心的可检测性而开发的。此外，它还是由 100% 的可回收塑料制成，原料来自水瓶。'},
			page13_text9:{title:'page13',name:'xx',text:'发现'},
			
			page14_text1:{title:'page14',name:'xx',text:'在法国的生产基地，我们优先使用可持续能源，并寻求创新的解决方案来改善我们的环境足迹。'},
			page14_text2:{title:'page14',name:'xx',text:'我们的物流基地（法国最大的物流基地之一，覆盖了基地办公室 100%的能源消耗）一建成就安装了光伏屋顶。'},
			page14_text3:{title:'page14',name:'xx',text:'自 2021 年起，我们的工业基地开始使用沼气，每年可节约近 850 吨二氧化碳。'},
			page14_text4:{title:'page14',name:'xx',text:"此外，从 2024 年起，圣旺-洛莫讷（Saint-Ouen l'Aumône）物流基地将安装地热能源，使该基地的二氧化碳排放量减少-33%（与传统能源相比）。"},
			page14_text5:{title:'page14',name:'xx',text:'此外，我们还在各物流基地开展其他项目，以实现能源自主化，减少二氧化碳排放量。'},
			
			page15_text1:{title:'page15',name:'xx',text:'Sisley 致力于保护自然资源，无论是在其生产基地、从植物和原材料中提取的活性成分的采购过程中，还是在与法国和全球社区的合作中。为此，我们采取了一系列具体行动。'},
			
			page16_text1:{title:'page16',name:'xx',text:'为了保护自然资源，Sisley团队正在努力减少生产基地和产品生产过程中的用水量。'},
			page16_text2:{title:'page16',name:'xx',text:'我们生产基地的机器采用闭环回路和使用旋转喷嘴和加压喷射器的容器清洗系统，以节约用水。'},
			page16_text3:{title:'page16',name:'xx',text:'自 2019 年以来，我们生产基地每生产一吨产品的耗水量减少了28%。'},
			page16_text4:{title:'page16',name:'xx',text:'同时，Sisley 正在用更天然的替代品取代对环境或人类有风险的普通家用清洁产品。使用CLEANEA机器设备，利用电解产生两种溶液，一种是消毒剂（H+），另一种是脱脂剂（OH-）。'},
			page16_text5:{title:'page16',name:'xx',text:'此外，我们还在生产车间安装了一个废水处理设备，用于处理工业废水，限制对下游的水污染。'},
			page16_text6:{title:'page16',name:'xx',text:'经过 100% 处理的水可去除部分污染，使其可以排放到自然环境中。'},
			
			page17_text1:{title:'page17',name:'xx',text:'四十多年来，Sisley法国希思黎的研究实验室一直专注于植物世界的研究。'},
			page17_text2:{title:'page17',name:'xx',text:'我们的团队从世界各地精心挑选植物，提取我们确定的活性成分：外来的或特有的，栽培的或野生的。在选择这些植物时，我们尊重生物多样性和当地社区。有些植物是有机种植的，有些则是根据可持续农业协议种植的。'},
			page17_text3:{title:'page17',name:'xx',text:'副产品的回收和植物废弃物的循环利用'},
			page17_text4:{title:'page17',name:'xx',text:'HAND IN HAND WITH OUR SUPPLIERS'},
			page17_text5:{title:'page17',name:'xx',text:'目前，我们的团队正在努力创建一个 Sisley 参照系统，对以下六项标准进行测量和评估：天然性、碳足迹、社会和环境风险、环境安全性、对生物多样性的贡献以及可追溯性。我们的目标是在 2025 年之前，根据这一基准分析我们的全部产品目录，以便对原材料对环境的影响进行仲裁和改进。'},
			page17_text6:{title:'page17',name:'xx',text:'Sisley 选择与我们有着同样关注的合作伙伴：例如，参与棕榈油原料 RSPO 认证（可持续棕榈油圆桌会议，认证可持续棕榈油生产，即经济上可行、生态上适当、社会上有益）和濒危物种保护的供应商。'},
			
			page18_text1:{title:'page18',name:'xx',text:'在法国，我们还开展了保护当地物种的活动：设置蜂箱、发展生态牧场、种植当地特有的植物品种，以及在我们的场所种植 4000 棵树木和灌木等。'},
			page18_text2:{title:'page18',name:'xx',text:"在布洛瓦（Blois）和圣旺-洛莫讷（Saint-Ouen l'Aumône）地区，我们利用绿地和水域来促进生物多样性的维护和发展。这些绿地采用温和的维护方法：晚割草、不使用杀虫剂等。"},
			page18_text3:{title:'page18',name:'xx',text:'我们还安装了绿色屋顶和带绿谷的草坪停车场，以减少建筑对环境的影响，促进雨水渗透（防洪）。'},
			page18_text4:{title:'page18',name:'xx',text:'在巴黎总部，种植了植物的庭院上方有一堵绿墙，上面放置了鸟巢。'},
			
			page19_text1:{title:'page19',name:'xx',text:'我们在全球各地的 4900 名员工积极行动起来，为促进良好的环保行为献计献策。'},
			page19_text2:{title:'page19',name:'xx',text:'在垃圾分类方面，我们在各工厂设立了多个回收渠道，以鼓励良好行为：纸张、纸板、金属罐、玻璃、塑料盖、电池、堆肥等。每位新员工到岗时都会收到一个马克杯和一个水瓶，以避免使用一次性塑料。各团队正在通过在物流基地组织集市的方式，与当地 “农业 ”生产合作伙伴重新建立联系，重点推广当地有机市场园艺和手工产品。'},
			page19_text3:{title:'page19',name:'xx',text:'此外，还采取了多项措施，支持 Sisley 团队使用更可持续的交通方式：拼车、火车站和物流基地之间的轮换班车、电动车和混合动力车的电动终端......'},
			
			page20_text1:{title:'page20',name:'xx',text:'Sisley Tree Challenge 是一项国际体育挑战赛，于 2022 年首次诞生并启动，全球 33 家 分公司齐聚一堂，共同支持环保事业。第一届活动旨在支持澳大利亚的植树造林工作，与 “种一棵树”（One Tree Planted）公益环保组织合作种植了 78,000 多棵树。'},
			page20_text2:{title:'page20',name:'xx',text:'在 2023 年举办的第二届活动中，来自世界各地的 Sisley 团队齐心协力，通过在墨西哥恢复红树林来保护生物多样性。红树林是一个拥有丰富生物多样性的生态系统，生长在海洋世界和陆地世界的交界处：其特殊性使其对保护海岸线和土壤、应对全球变暖、碳捕获以及珊瑚礁和海草床的健康至关重要。'},
			page20_text3:{title:'page20',name:'xx',text:'2023 年夏天，Sisley 团队与大自然保护协会合作，在墨西哥普罗格雷索恢复了 60,000 平方米的红树林。在开展这一环保项目的同时，还开展了一项社会活动，由墨西哥港口城市切莱姆的一群妇女组成的Las Chelemeras领导，她们自2010年以来一直致力于保护和恢复当地的红树林。'},
			page20_text4:{title:'page20',name:'xx',text:'这次挑战不仅对我和我的团队来说是一次很好的团队建设经历，而且也是一次学习经历，让我们认识到红树林对整个世界的重要性，以及红树林对整个环境的影响。更让我们大家感到惭愧的是，我们了解到 Las Chelemeras 这群了不起的勇敢女性，她们通过在自己的社区做出巨大的改变，为所有人树立了榜样，证明了 “有志者事竟成”。感谢大家"。- 路易斯-奥图扎尔（Luis Ortuzar）--Sisley法国希思黎墨西哥分公司总经理 '},
			
			page21_text1:{title:'page21',name:'xx',text:'我们的主要目标是通过减少活动产生的二氧化碳排放量来减少对环境的影响。即使我们以最认真的态度和所有必要的严格要求来开展这项工作，也不可能完全实现碳中和，因为人类的所有活动都会产生影响。'},
			page21_text2:{title:'page21',name:'xx',text:' 因此，我们于 2021 年启动了 Sisley 自然计划。每年，该计划都会支持和资助与当地居民合作的碳捕获和环境保护项目，以及支持生物多样性和尊重生态系统的措施。'},
			
			page22_text1:{title:'page22',name:'xx',text:'保护环境和生物多样性 '},
			page22_text2:{title:'page22',name:'xx',text:'森林保护'},
			page22_text3:{title:'page22',name:'xx',text:"森林是全球濒临灭绝的生态系统，是大量动植物的家园，必须加以保护。Sisley 正在研究退化森林重建、植树造林和原始森林保护项目，并因此与法国国家林业局（ONF）建立了合作伙伴关系。2022 年，在受栗树病'墨汁'影响的几块栗树林被砍伐后，Sisley 在法国国有森林（Forêt Domaniale de Fausses-Reposes，92 年）种植了 5,700 多棵不同品种的树木（橡树、野樱桃等）。"},
			page22_text4:{title:'page22',name:'xx',text:'保护海洋海草'},
			page22_text5:{title:'page22',name:'xx',text:'自 2021 年以来，Sisley 一直是法国克罗斯港国家公园/ 波克罗勒岛国家公园的合作伙伴，致力于保护大洋海神草。大洋海神草是地中海盆地生物多样性的一个重要生态系统，也是一个真正的碳汇，但由于船只的潮湿而受到破坏。为此，我们为小学生编写了一本围绕 大洋海神草的教育活动手册，以提高他们对生物多样性、气候变化、污染和生态系统保护等问题的认识。'},
			page22_text6:{title:'page22',name:'xx',text:'生物多样性和农业生态学'},
			page22_text7:{title:'page22',name:'xx',text:'Sisley 通过其基金会支持法国塞夫朗的农业高中这一创新项目，以具体和可持续的方式对初中和高中学生进行培训，让他们了解农业转型的挑战和未来生活各领域的职业：保护生物多样性、生产健康的本地食品、使农业和林业实践适应气候变化、树木在生产系统中的正确位置，甚至是传统与创新技术的结合。'},
			page22_text8:{title:'page22',name:'xx',text:'保护自然资源，融入当地居民'},
			page22_text9:{title:'page22',name:'xx',text:'反对塑料污染，促进社会融合'},
			page22_text10:{title:'page22',name:'xx',text:'Sisley 及其基金会发起了一个创新项目：Fâro 项目，旨在通过提高废物收集效率来减少塑料污染。该试点项目最初是与突尼斯可持续智能城市协会（MEGARA for Sustainable Smart Cities）合作，在突尼斯的苏克拉（Soukra）社区实施的。该项目以移动应用程序为基础，将所有参与垃圾收集的人员（住户、拾荒者、收集者）联系起来，通过当地的回收渠道，大幅增加塑料的回收量。该项目的预期目标，除了通过使用数字工具进行创新外，还具有社会性质，因为它将参与者重新纳入正规渠道。它将被用于其他受到塑料污染困扰的地区。'},
			page22_text11:{title:'page22',name:'xx',text:'保护自然资源，赋予妇女权力'},
			page22_text12:{title:'page22',name:'xx',text:`自 2017 年以来，Sisley-d'Ornano多纳诺基金会会一直为非政府组织 Noé 提供支持，该组织的目标是在生物多样性受到威胁的地区保护和恢复生物多样性。继 2019 年在喀麦隆德贾 自然生物保护区的热带森林提供初步支持后，自 2022 年起，基金会通过部署负责任的部门和推广喀麦隆有机优质林业和农林产品，支持在喀麦隆贝努埃国家公园外围开发社区可持续管理项目。`},
			page22_text13:{title:'page22',name:'xx',text:'该项目是协会长期承诺的一部分，协会已在喀麦隆培训了 470 多名妇女，保护了 4 000 多公顷的森林。'},
			
			// page23_text1:{title:'',name:'xx',text:''},
			
			tk1_text1:{text:"创建 Sisley法国希思黎，成为植物美容领域的先驱"},
			tk1_text2:{text:"收购位于布洛瓦（Blois）的 Francos 工厂，并投资对其进行现代化改造，特别是在能源效率方面 "},
			tk1_text3:{text:"创建 Sisley-多纳诺基金会，其主要承诺之一是支持环保"},
			tk1_text4:{text:"首次企业社会责任审计和行动计划"},
			tk1_text5:{text:"收购圣旺-洛莫讷（Saint-Ouen l'Aumône）物流基地，并在法国建造了首个获得高环境质量评价体系（HQE）认证的仓库。"},
			tk1_text6:{text:"安装法国北部最大的光伏屋顶"},
			tk1_text7:{text:"法国生产基地首次获得环境、健康、卫生与安全（ISO 14001 和 45001）"},
			tk1_text8:{text:"在圣旺-洛莫讷（Saint-Ouen l'Aumône）工厂进行首次能源审计。然后在 2023 年对布洛瓦（Blois）生产场地进行能源审计。"},
			tk1_text9:{text:"巴黎新总部通过 HQE 认证"}, //17
			tk1_text10:{text:"第二次企业社会责任审计和《2020-2030行动计划》"},
			tk1_text11:{text:"在布洛瓦（Blois）场地建造一座污水处理厂，以处理工业废水"},
			tk1_text12:{text:"第二次企业社会责任审计和 2020-2030 年行动计划 为保护生物多样性"}, //21
			tk1_text13:{text:"制定了 “Sisley for nature ”计划 最终确定了十年行动计划，将布洛瓦（Blois）每个产品的能耗降低50%"},
			tk1_text14:{text:"在工业生产基地改用沼气"},
			tk1_text15:{text:"与化妆品行业的其他企业共同制定环保方针（Eco-Beauty Score Consortium联盟）。"},
			tk1_text16:{text:"此后"},
			
			tk2_text1:{text:"Sisley 加入了多个行业倡议，以进一步推进其项目。其中，“纸浆行动 ”倡议得到了RE(SET) 商业环保战略咨询公司和其他化妆品品牌的支持，旨在开发一种基于纤维素纤维的包装解决方案。Sisley 还是Eco-Beauty Score Consortium联盟的成员，该联盟由国际化妆品行业的 60 多家公司联合发起，旨在对化妆品产品进行共同的环境保护展示。"},
			
			
		},
		page4_type:'1',
		// 123457
		page4_types:{
			'type1':{
				img:g+"/Colour_Environmental-projects.png",
				text:'',
				url:'',
			},'type2':{
				img:g+"/Colour_Packaging-eco-conception.png",
				test:'',
				url:'',
			},'type3':{
				img:g+"/Colour_Biodiversity.png",
				test:'',
				url:'',
			},'type4':{
				img:g+"/Colour_Our-sites.png",
				test:'',
				url:'',
			},'type5':{
				img:g+"/Colour_Formulas-Phyto-cosmetology.png",
				test:'',
				url:'',
			},'type7':{
				img:g+"/Colour_Energy-transportation.png",
				test:'',
				url:'',
			},
			
		},
		isShow:{
			tk1:false,
		},
		showTKKey:"",
		keyWords:'',
		textPageList:[],
		NewPage:0,
	};
  },
  created() {
	  // 监听屏幕尺寸
	  this.getSize(0)
	     window.onresize = () => {
	       // 定义窗口大小变更通知事件
	        // document.documentElement.clientWidth; //窗口宽度
			this.getSize(1)
	     };
	   
  },
  beforeDestroy() {
  	// 取消屏幕尺寸监听
	window.onresize =null;
	 window.onscroll =null;
	 let  hl=document.getElementsByTagName('html')
	hl[0].style['overflowY'] = 'auto';
  },
  mounted() {
	  // 图片视频懒加载
	  this.loadImage()
	  this.$nextTick(()=>{
		  this.toPlay("video1")
	  })
	  this.NewPage=this.getNewPage()
	  window.onscroll =()=>{
		 this.NewPage=this.getNewPage()
	  }
	  
  },
  methods: {
	  /** 计算布局 */
	  getSize(t){
		  if(t==0){
			  this.getSize1()
		  }else{
			  window.clearTimeout(this.isLoadSizeDs);
			  this.isLoadSizeDs= window.setTimeout(()=>{
				  this.getSize1()
			  },500);
			  
			  
			  
		  }
	  },
	  // next()
	  getSize1(){
		  let size=1;
		  let w=document.documentElement.clientWidth;
		  console.log(w)
		  if(w>=1920){
			  size=1;
		  }else{
			  size=w/1920
		  }
		  this.w=w;
		  this.size=size;
		  // 获取 page 1 视频宽高
		  this.$nextTick(()=>{
			  this.getPageSize();
			  // 弹框内容缩放
			  this.getTkSize()
		  })
	  },
	  /** 图片懒加载 */ 
	  loadImage(){
		     var lazyImages = [].slice.call(document.querySelectorAll('img[data-src]'));
		     if ('IntersectionObserver' in window) {
		         let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
		             entries.forEach(function(entry) {
		                 if (entry.isIntersecting) {
		                     let lazyImage = entry.target;
		                     lazyImage.src = lazyImage.dataset.src;
		                     lazyImage.classList.remove('lazy-image');
		                     lazyImageObserver.unobserve(lazyImage);
		                 }
		             });
		         });
		  
		         lazyImages.forEach(function(lazyImage) {
		             lazyImageObserver.observe(lazyImage);
		         });
		     } else {
		         // 回退方案：简单的onload监听方式
		         let lazyImagesLeft = lazyImages.length;
		         while (lazyImagesLeft--) {
		             let lazyImage = lazyImages[lazyImagesLeft];
		             lazyImage.addEventListener('load', function() {
		                 lazyImage.classList.remove('lazy-image');
		             });
		             lazyImage.src = lazyImage.dataset.src;
		         }
		     }
		 
	  },
	  /** 播放视频*/
	  toPlay(video_element) {
	    if (this.$refs?.[video_element]?.play) {
	      this.$refs[video_element].play();
	      // this.videoShow = false
	    }
	  },
	  getPageSize(){
		  let w=this.w
		  console.log('%O', this.$refs.page1,'====')
		  // 视频 page的高度获取
		  this.loadVieo("video1")
		  this.loadVieo("video2")
		  this.loadVieo("video3")
		  this.loadVieo("video4")
		  this.loadVieo("video5")
		  // 缩放
		 let pages1=[4,6,7,8,9,11,12,13,14,16,17,18,19,20,22];
		  if(w<1920){
			  for(let i=0;i<pages1.length;i++){
				  if(this.$refs['Vpage'+pages1[i]]&&this.$refs['page'+pages1[i] ]){
					  this.$refs['Vpage'+pages1[i]].style.height=(w/1920)*this.$refs['page'+pages1[i]].offsetHeight +'px'
				  }else{
					  console.log(pages1[i],i,'失效')
				  }
			  		
			  }
		  }else{
			  for(let i=0;i<=pages1.length;i++){
			  	if(this.$refs['Vpage'+pages1[i]]){
					this.$refs['Vpage'+pages1[i]].style.height='auto'
				}
			  }
		  }
		  let pages2=[2,3,21]
		  if(w<750){
		  			  for(let i=0;i<pages2.length;i++){
						  console.log(this.$refs['page'+pages2[i]].offsetHeight,'===')
		  				  if(this.$refs['Vpage'+pages2[i]]&&this.$refs['page'+pages2[i] ]){
		  					  this.$refs['Vpage'+pages2[i]].style.height=(w/960)*this.$refs['page'+pages2[i]].offsetHeight +'px'
		  				  }else{
		  					  console.log(pages2[i],i)
		  				  }
		  			  		
		  			  }
		  }else{
		  			  for(let i=0;i<=pages2.length;i++){
						  // console.log("高auto",pages2[i])
		  			  	if(this.$refs['Vpage'+pages2[i]]){
							this.$refs['Vpage'+pages2[i]].style.height=this.$refs['page'+pages2[i]].offsetHeight +'px'
						}
		  			  }
		  }
		  // let pages3=[5]
		  // for(let i=0;i<pages3.length;i++){
			 //  this.$refs['Vpage'+pages3[i]].style.height=this.$refs['page'+pages3[i]].offsetHeight +'px'
		  // }
	  },
	  /** 视频加载 */
	  loadVieo(name){
		  /* 
		  srcElement.
		  videoHeight
		  : 
		  1080
		  videoWidth
		  : 
		  1920*/
		  console.log('==========视频加载')
		  let videopages={
			  video1:'page1',
			  video2:"page5",
			  video3:"page15",
			  video4:"page23",
			  video5:"page10"
		  };
		  if(!videopages[name]){return};
		  this.$nextTick(()=>{
			  console.log(this.$refs[name].offsetHeight)
			  
			  this.$nextTick(()=>{
				  let w=this.w
				  if(w<960){
					  this.$refs[videopages[name]].style.height="100vh" ;//this.$refs[name].offsetHeight+'px';
					  this.$refs['V'+videopages[name] ].style.height=(w/960)*this.$refs[videopages[name]].offsetHeight +'px'
				  }else{
					  this.$refs[videopages[name]].style.height='100vh';
					  this.$refs['V'+videopages[name] ].style.height='auto'
				  }
			  })
		  })
		  
	  },
	  /**进入全屏模式*/
	  qp(){
		    if (!document.fullscreenElement) {  // 如果当前不在全屏模式
		      if (document.documentElement.requestFullscreen) {
		        document.documentElement.requestFullscreen(); // 进入全屏模式
		      } else if (document.body.requestFullscreen) {
		        document.body.requestFullscreen(); // 在某些浏览器中，需要使用body
		      }
		    } else { // 如果当前在全屏模式
		      // if (document.exitFullscreen) {
		      //   document.exitFullscreen(); // 退出全屏模式
		      // }
		    }
		  },
		/** 当前所在页面  */
		getNewPage(){
		    // 1-23
			let visibleElements=[]
			for(let i=1;i<=23;i++){
				const element = this.$refs['page'+i]
				console.log(this.isInViewport(element),i)
				if(this.isInViewport(element)){
					console.log("可视页面为 page"+i)
					return  i;
				}
				}
				return 23
				console.log("可视视图为最后一个：page23")
		  },
	  /**分享*/
	  fx(){
		    // 1-23
			let visibleElements=[]
			for(let i=1;i<=23;i++){
				const element = this.$refs['page'+i]
				console.log(this.isInViewport(element),i)
				if(this.isInViewport(element)){
					console.log("可视页面为 page"+i)
					return ;
				}
				}
				console.log("可视视图为最后一个：page23")
		  },
		   isInViewport(element) {
		    const rect = element.getBoundingClientRect();
			console.log(rect,window.innerHeight || document.documentElement.clientHeight,'==可视')
			// 
		    return (
		      rect.top >= 0
		    );
		  },
		  /** 鼠标悬停*/
		  onhover(p,t){
			  console.log(p,t)
			  if(p=='page4'){
				  this.page4_type=t;
			  }
		  },
		  /** 显示弹框*/
		  showTK(tk){
			  let  hl=document.getElementsByTagName('html')
			  this.$set(this.isShow,tk,true)
			  this.showTKKey=tk;
			   hl[0].style['overflowY'] = 'hidden';
			   this.getTkSize()
		  },
		  /** 隐藏弹框 */
		  hideTK(tk){
			  let  hl=document.getElementsByTagName('html')
			  this.$set(this.isShow,tk,false)
			  hl[0].style['overflowY'] = 'auto';
		  },
		  /** 弹框缩放 */
		  getTkSize(){
			  this.$nextTick(()=>{
				  if(this.$refs[this.showTKKey+'_V']){
					  // 当元素宽度为960时缩放 不影响高度计算
					  if(this.w>=1500){
						  this.$refs[this.showTKKey+'_V'].style.height="auto"
					  }else{
						  this.$refs[this.showTKKey+'_V'].style.height=(this.$refs[this.showTKKey+'_view'].offsetHeight*(this.w/1500)) +'px'
					  }
					  
					  console.log(this.$refs[this.showTKKey+'_view'].offsetHeight)
				  }
			  })
		  },
		  /** 跳转ref */
		    scrollToRef(refName) {
		        this.$nextTick(() => {
		          const element = this.$refs[refName];
				  console.log(this.$refs.refName,this.$refs)
		          if (element) {
					  console.log("跳转",element)
		            element.scrollIntoView({ behavior: 'smooth' });
		          }
		        });
		      },
			 /** 跳转到外部 */
			 toOutside(uri){
				 window.open(uri, '_blank');
			 },
			 //搜索
			  getTextPage(){
				  console.log(this.keyWords)
				  let list =[];
				  for(let i in this.texts){
					  if(this.texts[i].text&&this.texts[i].text.indexOf(this.keyWords)!=-1&&this.texts[i].title){
						  list.push(this.texts[i])
					  }
				  }
				  console.log(list)
				  this.textPageList=list;
			  },
			  // 搜索 跳转
			  keyWordsToPage(item){
				  this.hideTK('tk5')
				  this.scrollToRef(item.title)
			  },
			  // 导航页点击事件
			  toStb(type){
				  
				  if(this.isShow.tk6){
					  this.hideTK('tk6')
				  }
				  		  //1 2 3 4
				  		  if(type==1){
							  
				  			  this.scrollToRef('page1')
				  		  }else if(type==2){
				  			  this.scrollToRef('page2')
				  		  }else if(type==3){
				  			  this.scrollToRef('page5')
				  		  }else if(type==4){
				  			  this.scrollToRef('page10')
				  		  }else if(type==5){
				  			  this.scrollToRef('page15')
				  		  }else if(type==6){
				  			  // 邮箱
				  			  // this.fx()
				  		  }else if(type==7){
				  			  // 全屏
				  			  this.qp()
				  		  }else if(type==8){
				  			  // pdf
				  			  this.toOutside(this.baseUel+'file/sustainability_2.pdf')
				  		  }else if(type==9){
				  			  // 搜索
				  			  this.showTK('tk5')
				  		  }
				  
			  }
		  
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
	@import "./index.scss";

</style>